// Texts for login page
const login = {
    loginTitle: 'Conexión',

    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'ejemplo@correo.com',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: 'Escriba su contraseña',

    showPasswordLabel: 'Mostrar contraseña',

    loginButtonLabel: 'Conectarse',
};

export default login;
